import { Box, Portal } from '@chakra-ui/react';
import { ZIndex } from '@/utils/zIndex.ts';

const ComposerFocusBackdrop = () => (
	<Portal>
		<Box
			aria-hidden
			className="composer-dock-backdrop"
			display={{ base: 'none', md: 'block' }}
			position="fixed"
			inset={0}
			zIndex={ZIndex.ComposerBackdrop}
			bg="blackAlpha.600"
			css={{
				transition: 'opacity 150ms ease',
				'@media (prefers-reduced-motion: reduce)': { transition: 'none' },
			}}
		/>
	</Portal>
);

export default ComposerFocusBackdrop;
